export const associateArray = (array, propName) =>
  array.reduce((object, item) => {
    object[item[propName]] = item;
    return object;
  }, {});
